import axios from "axios";
//import store from "../store/index";
import config from "../config";

export default {
  getHolidays(context, success, error) {
    axios({
      url: config.URLS.i5Scheduler + `holiday/${context.selectedYear}`,
      method: "GET"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  createHoliday(context, success, error) {
    axios({
      url: config.URLS.i5Scheduler + "holiday",
      data: context.addUpdateHolidayPayLoad,
      method: "POST"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  updateHoliday(context, success, error) {
    axios({
      url:
        config.URLS.i5Scheduler + `holiday/${context.updateHolidayID}`,
      data: context.addUpdateHolidayPayLoad,
      method: "PUT"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  deleteHoliday(context, success, error) {
    axios({
      url: config.URLS.i5Scheduler + `holiday/${context.deleteItemID}`,
      method: "DELETE"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  }
};
